export enum PermissionType {
  ADMIN = 'ADMIN',
  FLIGHTROOM = 'FLIGHTROOM',
}
